import Reflux from "reflux";

import SFLeadsDataActions from "../actions/salesForce/sFLeadsDataActions";

const SFLeadsDataActionsStore = Reflux.createStore({
  listenables: SFLeadsDataActions,

  init: function() {
    this.leads = [];
  },
  onUpdateSFLeads: function(leads) {
    this.leads = leads;
    this.trigger(this.leads);
  },
});

window.SFLeadsDataActionsStore = SFLeadsDataActionsStore;
export default SFLeadsDataActionsStore;
